/**
 * Notification types used to filter notification in the notification menu.
 */
export const NotificationType = {
    All: null,
    New: 'new',
    Read: 'read'
};
